import { useMemo } from 'react';
import { useAuth } from '../userManagement/AuthContext';

// The login CHANNEL decides the session type, not the account's permissions:
// - Customer Login (OTP) => booking-only customer view, even for staff accounts.
// - Normal login => full experience according to permissions.
// Legacy sessions without a channel flag fall back to permission inference.
const STAFF_PERMISSIONS = [
  'view_repair_process',
  'view_assigned_repair_process',
  'view_spare_parts',
  'view_supply',
  'view_finance',
  'view_users',
  'view_tags',
  'view_logistics',
  'view_logistics_tours',
  'view_map',
  'view_documents',
  'view_notifications',
  'view_bug_reports',
  'manage_bug_reports',
  'admin_access',
  'view_communication',
  'send_communication',
  'dial_communication',
  'manage_communication',
  'admin_access'
];

const useIsCustomerOnly = () => {
  const { user } = useAuth();

  return useMemo(() => {
    const channel = localStorage.getItem('loginChannel');
    if (channel === 'customer') return true;
    if (channel === 'staff') return false;

    // Legacy fallback: infer from permissions
    if (!user) return false;
    const hasCustomerAccess = user.roles?.includes('Customer') ||
      user.roles?.includes('customer') ||
      user.tags?.includes('Customer') ||
      user.tags?.includes('customer') ||
      user.permissions?.includes('view_bookings') ||
      user.permissions?.includes('create_bookings');

    if (!hasCustomerAccess) return false;

    const hasStaffAccess = user.is_admin ||
      user.permissions?.some(p => STAFF_PERMISSIONS.includes(p));

    return !hasStaffAccess;
  }, [user]);
};

export default useIsCustomerOnly;
